import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { LoggedInUserFragmentFragment } from 'data/__generated__';

/**
 * Hook pour configurer automatiquement le contexte utilisateur dans Sentry
 * @param user - L'utilisateur connecté ou null
 */
export const useSentryUser = (user: LoggedInUserFragmentFragment | null) => {
    useEffect(() => {
        if (user) {
            Sentry.setUser({
                id: user._id,
                username: user.username,
            });
        } else {
            Sentry.setUser(null);
        }
    }, [user]);
};
